import { c as _c } from "react/compiler-runtime";
import { EntityLookup } from './EntityLookup';
import type { LookupOption } from '@/components/ui/lookup';
import type { ApiEntity } from '@/lib/api/types';
interface BrandLookupProps {
  value?: LookupOption<ApiEntity> | null;
  onChange: (value: LookupOption<ApiEntity> | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  /** When provided and no value is set, fetches the brand by ID and auto-selects it */
  initialId?: number | string;
}
export function BrandLookup(t0) {
  const $ = _c(7);
  const {
    value,
    onChange,
    placeholder: t1,
    className,
    disabled,
    initialId
  } = t0;
  const placeholder = t1 === undefined ? "Search brands..." : t1;
  let t2;
  if ($[0] !== className || $[1] !== disabled || $[2] !== initialId || $[3] !== onChange || $[4] !== placeholder || $[5] !== value) {
    t2 = <EntityLookup value={value} onChange={onChange} entityType="brand" placeholder={placeholder} className={className} disabled={disabled} initialId={initialId} />;
    $[0] = className;
    $[1] = disabled;
    $[2] = initialId;
    $[3] = onChange;
    $[4] = placeholder;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}